import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  chip: {
    display: 'inline-block',
    marginTop: 2,
    padding: '0 8px',
    borderRadius: 10,
    fontSize: '0.72rem',
    fontWeight: 600,
    lineHeight: 1.6,
    whiteSpace: 'nowrap',
    background: 'rgba(110, 118, 129, 0.15)',
    color: 'var(--ui-text-muted)',
  },
});

const TITLE =
  'A customer project, not a revenexx service: kept here for the team that works on it';

/**
 * The mark of a customer project's row in CI health and Deployments (DX-681).
 *
 * Customer projects are not revenexx services and stay out of the portal; the
 * one kept, `revenexx/nord`, is kept for its team's sake, and says so here so
 * nobody else reads it as one of ours. Grey, like any label that is not a
 * verdict, and on a line of its own beneath the repository, so it is never
 * the part of a narrow cell that is cut off.
 */
export const CustomerProjectChip = () => {
  const classes = useStyles();
  return (
    <div>
      <span className={classes.chip} title={TITLE}>
        Customer project
      </span>
    </div>
  );
};
